import { Button, Result } from 'antd';
import React from 'react';

function ErrorFallback({ error, resetErrorBoundary }) {
    return (
        <div className='p-2 bg-white'>
            <Result
                status="500"
                title="500"
                subTitle="Sorry, something went wrong."
                extra={<>
                    <pre>{error.message}</pre>
                    <Button
                        onClick={resetErrorBoundary}
                        type="primary">
                        {/* <FontAwesomeIcon icon={faArrowsRotate} /> */}
                        &nbsp;&nbsp;
                        Refresh Page</Button></>}
            />

        </div>
    )
}



export default ErrorFallback